import React, { FC, useState, ChangeEvent, useRef } from 'react'
import styles from './DragFileInput.module.scss'
import { Text } from 'components/Text'
import { useId } from '@reach/auto-id'
import { Icon } from 'components/Icon'
import { useTranslation } from 'react-i18next'
import { Flex } from 'components/Flex'
import { Alert } from 'components/Alert'

type FileValue = {
  name: string
  url: string
}

type DragFileInputProps = {
  label: string
  acceptedFiles: string[]
  name?: string
  value?: FileValue
  description?: string
  accept?: string
  required?: boolean
  onChange?: (data: File) => void
}

export const DragFileInput: FC<DragFileInputProps> = ({
  description,
  label,
  acceptedFiles,
  name,
  value,
  onChange,
  accept,
  required = false,
}) => {
  const { t } = useTranslation()
  const inputId = useId()
  const inputRef = useRef<HTMLInputElement>(null)
  const [file, setFile] = useState<any>(value)
  const desc = description || t('file_input.description')
  const [fileNotAllowed, setFileNotAllowed] = React.useState(false)

  const onInputChanged = (event: ChangeEvent<HTMLInputElement>) => {
    const data = event.target.files?.[0]

    if (!data) return

    const file = {
      name: data.name,
      url: URL.createObjectURL(data),
    }

    setFile(file)
    onChange && onChange(data)
  }

  const handleDragOver = (e: any) => {
    e.preventDefault()
  }

  const handleDrop = (e: any) => {
    e.preventDefault()

    const fileExtension = e.dataTransfer.files[0].name.split('.').pop()

    if (acceptedFiles.indexOf(fileExtension) > -1) {
      setFile(e.dataTransfer.files[0])

      const data = e.dataTransfer.files?.[0]

      if (!data) return

      const file = {
        name: data.name,
        url: URL.createObjectURL(data),
      }

      setFile(file)
      onChange && onChange(data)
    } else {
      setFileNotAllowed(true)
      setTimeout(() => setFileNotAllowed(false), 7000)
    }
  }

  const onSelectFile = (e: React.FormEvent) => {
    e.preventDefault()

    inputRef.current?.click()
  }

  return (
    <React.Fragment>
      {fileNotAllowed && (
        <Flex justify="between" className={styles.alertWrapper}>
          <Alert tone="critical" full>
            El tipo de archivo no es compatible con ésta función.
          </Alert>
        </Flex>
      )}

      <Flex justify="between" className={styles.fileInput}>
        {/*isImage(file) && (
        <div className={styles.preview}>
          <img src={file!.url} alt={file!.name} />
          <button onClick={resetImage} aria-label={t('file_input.remove_image')}>
            <Icon name="close-fill" />
          </button>
        </div>
      )*/}

        {!file && (
          <div className={styles.dropBox} onDragOver={handleDragOver} onDrop={handleDrop}>
            <label className={styles.labelWrapper} htmlFor={inputId}>
              <Text weight="strong">Arrastra y suelta el archivo</Text>
              <Text size="small" truncate>
                {file ? file.name : desc}
              </Text>
              <div className={styles.divisionWrapper}>
                <hr className={styles.division} />
                <Text weight="strong">o</Text>
                <hr className={styles.division} />
              </div>
            </label>

            <button className={styles.selectFile} onClick={onSelectFile}>
              Seleccionar archivo
            </button>

            {/*<Text size="small" truncate>
          {file ? file.name : desc}
    </Text>*/}

            <input
              id={inputId}
              type="file"
              onChange={onInputChanged}
              ref={inputRef}
              accept={accept}
              required={required}
              hidden
            />
          </div>
        )}

        {file && (
          <div className={styles.preUploadWrapper}>
            <div className={styles.datasetData}>
              <Text weight="strong">{name}</Text>
              <div className={styles.fileData}>
                <div className={styles.iconWrapper}>
                  <Icon size="3x" name="file-upload-line" />
                </div>
                <Text>{file.name}</Text>
              </div>
              <div className={styles.barWrapper}></div>
              <button className={styles.selectFile} onClick={onSelectFile}>
                Cambiar archivo
              </button>

              <input
                id={inputId}
                type="file"
                onChange={onInputChanged}
                ref={inputRef}
                accept={accept}
                required={required}
                hidden
              />
            </div>
          </div>
        )}
      </Flex>
    </React.Fragment>
  )
}

DragFileInput.displayName = 'DragFileInput'

/*const isImage = (file?: FileValue) => {
  // eslint-disable-next-line eqeqeq
  if (file == undefined) return false

  const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
  return ['png', 'jpg', 'jpeg', 'gif'].includes(extension)
}*/
